import { Suspense, lazy } from "react"
import { useLocation } from "@tanstack/react-router"
import Header from "@/components/Header"
import { isTripOrGuidePage } from "@/lib/is-trip-or-guide-page"

// We have exactly two headers: the immersive EditorHeader for trip/guide pages,
// and the plain Header for everything else. This is the only place that picks
// between them — by route, via isTripOrGuidePage. EditorHeader depends on the
// layout/reorder/expand/chat providers, so only mount it where those exist
// (the authenticated shell and the optional-sidebar layout).
//
// EditorHeader is lazy: it pulls TripCreateModal (+ motion) and the editor
// chrome, none of which the public guide-read / explore pages render — but a
// static import here dragged all of it onto their logged-out cold wave. The
// fallback reserves the header height so the swap doesn't shift content.
const EditorHeader = lazy(() =>
  import(`@/components/EditorHeader`).then((m) => ({ default: m.EditorHeader }))
)

export function SiteHeader() {
  const { pathname } = useLocation()
  if (!isTripOrGuidePage(pathname)) return <Header />
  return (
    <Suspense fallback={<div className="h-[var(--header-height,3.25rem)]" />}>
      <EditorHeader />
    </Suspense>
  )
}
